export default __webpack_public_path__ + "static/media/illus3.1c2ab489.jpg";